import { inject, Injectable } from '@angular/core';
import { TaskWorkspaceStore } from '../../../../core/h3ml/state/task-workspace-store';
import { EventTrackingService } from '../../../../shared/event-tracking/event-tracking.service';

@Injectable()
export class SidePanelDisplayService {
  private readonly sidePanelStore = inject(TaskWorkspaceStore)('sidePanel');
  private eventTrackingService = inject(EventTrackingService);

  showClassSelector(source: string) {
    this.sidePanelStore('annotationPanelState').set('class_selector');
    this.eventTrackingService.track({
      id: 'open_class_selector',
      bucket: 'navigation',
      sub_bucket: 'frame',
      source,
    });
  }

  hideClassSelector(source?: string) {
    const annotationPanelStore = this.sidePanelStore('annotationPanelState');
    if (annotationPanelStore.state() !== 'class_selector') {
      return;
    }
    annotationPanelStore.set('annotation_list');
    if (source) {
      this.eventTrackingService.track({
        id: 'close_class_selector',
        bucket: 'navigation',
        sub_bucket: 'frame',
        source,
      });
    }
  }
}
